import { render, staticRenderFns } from "./sjxq.vue?vue&type=template&id=2f496748&"
import script from "./sjxq.vue?vue&type=script&lang=js&"
export * from "./sjxq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports